import CardColumn from '../CardColumn/CardColumn'
import './HomeCards.css'

export default function HomeCards({ page }) {
  console.log('HomeCards rendered')

  let columns = []
  page.columns.forEach((column) => {
    columns.push(<CardColumn key={column.id} column={column} />)
  })

  return (
    <div className="home-cards" data-cy-home-cards="true">
      {columns}
    </div>
  )
}
